import { Pagination } from "../Pagination";
import { BaseSearchFilter } from "./BaseSearchFilter";

export class ItemDeptRequest extends BaseSearchFilter {

    DeptCode!: string;
    DeptName!: string;
    pagination: Pagination = new Pagination;
}